import React, { Component, PropTypes } from "react";
import { Link } from "react-router/es";
import Dropdown from "./Dropdown";
import { eventType } from "constants/menuItemsData";
import { createBatchRecipeAsync } from "actions/recipe";
import { createEvent } from "googleanalytics";
import { routeCodes, subRouteCodes } from "constants/routes";
import { withRouter } from "react-router/es";

import { updateDesign } from "actions/design";
import moment from "moment";
import TypeItem from "records/TypeItem";

class MenuItems extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    router: PropTypes.object,
    userData: PropTypes.object,
    currentBrand: PropTypes.object,
    designs: PropTypes.object,
    typeItems: PropTypes.object,
    design: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.state = {
      dropdown: false,
    };
    this.ref = null;
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleOutsideClick);
    document.addEventListener("touchstart", this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleOutsideClick);
    document.removeEventListener("touchstart", this.handleOutsideClick);
  }

  handleOutsideClick = (event) => {
    const { dropdown } = this.state;
    if (dropdown && this.ref && !this.ref.contains(event.target)) {
      this.setState({ dropdown: false });
    }
  };

  onMouseEnter = () => {
    this.setState({ dropdown: true });
  };

  onMouseLeave = () => {
    this.setState({ dropdown: false });
  };

  toggleDropdown = () => {
    this.setState((prevState) => ({ dropdown: !prevState.dropdown }));
  };

  closeDropdown = () => {
    const { dropdown } = this.state;

    if (dropdown) {
      this.setState({ dropdown: false });
    }
  };

  createNewDesign = (id) => {
    const { dispatch } = this.props;
    let { design, designs, currentBrand, typeItems } = this.props;
    console.log(design, typeItems);

    const typeItem = TypeItem.findTypeItemById(typeItems, id);
    const location = currentBrand.getDefaultLocation();

    design = design.set("designTypeItemId", id);
    design = design.set("designTypeName", typeItem.get("typeItemName"));
    design = design.set("ordinal", designs.size);
    design = design.set("locationId", location.get("id"));
    design = design.set("ordinal", designs.size);
    dispatch(updateDesign(design));
  };

  createBatchRecipe = () => {
    const { router, currentBrand, dispatch, userData } = this.props;
    const formData = new FormData();
    formData.append(
      "recipe",
      JSON.stringify({
        brandId: currentBrand.get("id"),
        recipeCategoryId: "-1",
        recipeName: `My Batch Recipe ${moment().format("MMDDYY")}`,
        archived: false,
        isFromSysco: false,
        isBatchRecipe: true,
        servings: 1,
        batchlevel: 0,
        yieldUnits: 1200,
      })
    );

    dispatch(createBatchRecipeAsync(formData)).then((batchRecipe) => {
      createEvent("Recipes", "Add a BatchRecipe", "New BatchRecipe", userData);
      router.push(
        `${routeCodes.INGREDIENTS}${subRouteCodes.INGREDIENTS.BATCH_MANAGE_RECIPE}/${batchRecipe.id}`
      );
    });
  };

  openRecentDesign = (id) => {
    const { router } = this.props;
    router.push(`${routeCodes.DESIGNER}/${id}`);
  };

  render() {
    const {
      items,
      depthLevel,
      typeItems,
      design,
      designs,
      userData,
      dispatch,
      currentBrand,
    } = this.props;
    const { dropdown } = this.state;

    return (
      <li
        className={`menu-items ${
          depthLevel === 0 ? "top-level" : "inner-level"
        }`}
        ref={(node) => (this.ref = node)}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        onClick={this.closeDropdown}
      >
        {items.url && items.submenu ? (
          <div>
            <button
              type="button"
              aria-haspopup="menu"
              aria-expanded={dropdown ? "true" : "false"}
              onClick={this.toggleDropdown}
            >
              <Link to={items.url}>{items.title}</Link>
              {depthLevel > 0 ? "" : <span className="arrow" />}
            </button>
            <Dropdown
              depthLevel={depthLevel}
              submenus={items.submenu}
              dropdown={dropdown}
              typeItems={typeItems}
              design={design}
              designs={designs}
              userData={userData}
              dispatch={dispatch}
              currentBrand={currentBrand}
            />
          </div>
        ) : !items.url && items.submenu ? (
          <div>
            <button
              type="button"
              aria-haspopup="menu"
              aria-expanded={dropdown ? "true" : "false"}
            >
              {items.title}
              {depthLevel > 0 ? "" : <span className="arrow" />}
            </button>
            <Dropdown
              depthLevel={depthLevel}
              submenus={items.submenu}
              dropdown={dropdown}
              typeItems={typeItems}
              design={design}
              designs={designs}
              userData={userData}
              dispatch={dispatch}
              currentBrand={currentBrand}
            />
          </div>
        ) : items.isCallFunc &&
          items.eventType === eventType.CREATE_NEW_DESIGN ? (
          <Link
            onClick={() => this.createNewDesign(items.payload.id)}
            className={`${items.isBlueLink ? "bluelink" : ""} ${
              items.isHighlighted ? "highlighted" : ""
            }`}
            to={items.url}
          >
            {items.title}
          </Link>
        ) : items.isCallFunc &&
          items.eventType === eventType.ADD_BATCH_RECIPE ? (
          <Link
            onClick={() => this.createBatchRecipe()}
            className={`${items.isBlueLink ? "bluelink" : ""} ${
              items.isHighlighted ? "highlighted" : ""
            } menulinks`}
          >
            {items.title}
          </Link>
        ) : items.isCallFunc && items.eventType === eventType.RECENT_DESIGN ? (
          <Link
            onClick={() => this.openRecentDesign(items.payload.id)}
            className={`${items.isBlueLink ? "bluelink" : ""} ${
              items.isHighlighted ? "highlighted" : ""
            } menulinks`}
          >
            <div className="flex justify-between items-start full-width">
              <div className="nav-item-title-section">{items.title}</div>
              <div>{items.payload.id}</div>
            </div>
          </Link>
        ) : (
          <Link
            className={`${items.isBlueLink ? "bluelink" : ""} ${
              items.isHighlighted ? "highlighted" : ""
            }`}
            to={items.url}
          >
            {items.title}
          </Link>
        )}
      </li>
    );
  }
}

export default withRouter(MenuItems);
